import script from "./ModalParametrosRondasMas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalParametrosRondasMas.vue?vue&type=script&setup=true&lang=ts"

import "./ModalParametrosRondasMas.vue?vue&type=style&index=0&id=34415c7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34415c7e"]])

export default __exports__